<template>
  <div id="pageRoot">
    <span class="normalTheme pageInstruction" style="left: 62px; top: 60px;">
      <p>Tacha los nombres de los instrumentos musicales que no perdió el grillito.</p>
    </span>

    <label class="imageCheckBoxWTag">
      <input type="checkbox" name="4" value="Violin"
      ref="1" 
      v-on:click="saveOption('instrumentos', 1)" 
      :onload="loadOption('instrumentos', 1)"/>
        <span class="checkBoxMark" style="margin-left: 30px; margin-top: 130px; width: 300px; height: 400px">
          <div style="width: 100%; height: 70%; position: relative;" class="imageContainer">
            <img class="center" src="/pages/img/sordovio/assets_p7/violin.svg" style="width: 90%; max-height: 90%" />
          </div>
          <div style="width: 100%; height: 30%; position: relative">
            <div class="itemContainerTag textBase center">
              <p class="center">VIOLÍN</p>
            </div>
          </div>
        </span>
    </label>

    <label class="imageCheckBoxWTag">
      <input type="checkbox" name="5" value="Maracas"
      ref="2" 
      v-on:click="saveOption('instrumentos', 2)" 
      :onload="loadOption('instrumentos', 2)"/>
        <span class="checkBoxMark" style="margin-left: 370px; margin-top: 130px; width: 300px; height: 400px">
          <div style="width: 100%; height: 70%; position: relative;" class="imageContainer">
            <img class="center" src="/pages/img/sordovio/assets_p7/maracas.svg" style="width: 90%; max-height: 90%" />
          </div>
          <div style="width: 100%; height: 30%; position: relative">
            <div class="itemContainerTag textBase center">
              <p class="center">MARACAS</p>
            </div>
          </div>
        </span>
    </label>

    <label class="imageCheckBoxWTag">
      <input type="checkbox" name="6" value="Pandereta"
      ref="3" 
      v-on:click="saveOption('instrumentos', 3)" 
      :onload="loadOption('instrumentos', 3)"/>
        <span class="checkBoxMark" style="margin-left: 710px; margin-top: 130px; width: 300px; height: 400px">
          <div style="width: 100%; height: 70%; position: relative;" class="imageContainer">
            <img class="center" src="/pages/img/sordovio/assets_p7/pandereta.svg" style="width: 90%; max-height: 90%" />
          </div>
          <div style="width: 100%; height: 30%; position: relative">
            <div class="itemContainerTag textBase center">
              <p class="center">PANDERETA</p>
            </div>
          </div>
        </span>
    </label>

    <div class="textBubble" style="width:500px; height: 100px; left: 520px; margin-top: 550px;">
      <div class="textContainer textBase center" style="width: 90%; height: 90%;">
          <p class="center">Completa el enunciado con el nombre del instrumento que perdió.</p>
      </div>
      <img class="arrow left" src="/pages/img/general/textBubbleArrow.svg" style="top: 80px; left:360px;"/>
    </div>

    <p class="textBase" style="top: 675px; left: 120px; font-size:32px; position: absolute;">EL GRILLITO PERDIÓ EL </p>
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />

  </div>
</template>
<style scoped>
#inputField01 {
  position: absolute;
  width: 353px;
  left: 490px;
  top: 662px;
}
</style>
<script>
  export default {
    methods:{
      dbId(name, option){
        return `${this.$parent.type}-${this.$parent.page}-${name}-${option}`
      },
      async loadOption(name, option) {
        var id = this.dbId(name, option);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[option].checked=value.option;

        console.log("option loaded: " + id + ", " + value.option);
      },
      saveOption(name, option) {
        var id = this.dbId(name, option);
        var value = this.$refs[option].checked;

        this.$db.options.put({
              id: id,
              option: value
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + value);
      }
    },
    mounted(){

    }
  }
</script>